(function () {
    'use strict';
    angular.module('app').directive('selectioncommandacquirecheckout', selectioncommand_acquirecheckout);
    function selectioncommand_acquirecheckout() {
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                acquireCheckOutDialogShown: '=?'
            },
            controller: 'acquirecheckout',
            templateUrl: 'app/selectioncommand/selectioncommand_acquirecheckout.html'
        };
        return directive;
        function link(scope, element, attrs) {
        }
    }
})();